import { render } from "./vpostgoodslistadd.vue?vue&type=template&id=4b133d5c&scoped=true"
import script from "./vpostgoodslistadd.vue?vue&type=script&lang=js"
export * from "./vpostgoodslistadd.vue?vue&type=script&lang=js"

import "./vpostgoodslistadd.vue?vue&type=style&index=0&id=4b133d5c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b133d5c"]])

export default __exports__